module.exports = __webpack_public_path__ + "static/media/close (1).98dec13c.svg";